import React from "react";
import BlogCard from "./BlogCard";

export default function Blogs() {
  // ✅ Dynamic data array (you can replace with API later)
  const blogs = [
    {
      id: 1,
      title: "How to Build a Modern React UI",
      excerpt:
        "Learn best practices for building fast, reusable, and clean UI components in React.",
      image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200",
      author: "Team Oslolabs",
      date: "Feb 23, 2026",
      tag: "React",
    },
    {
      id: 2,
      title: "SEO Basics for Business Websites",
      excerpt:
        "A simple guide to improve search rankings with content, structure, and on-page SEO tips.",
      image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200",
      author: "Marketing Desk",
      date: "Feb 20, 2026",
      tag: "SEO",
    },
    {
      id: 3,
      title: "Why Vite is Faster than CRA",
      excerpt:
        "Understand why Vite is the new default choice for modern frontend development workflows.",
      image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200",
      author: "Engineering",
      date: "Feb 18, 2026",
      tag: "Tooling",
    },
  ];

  return (
    <section style={sectionStyle}>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <h2 style={{ margin: 0 }}>Latest Blogs</h2>
          <p style={{ margin: "8px 0 0", opacity: 0.8 }}>
            Explore insights, guides, and updates from our team.
          </p>
        </div>

        <div style={gridStyle}>
          {blogs.map((blog) => (
            <BlogCard
              key={blog.id}
              title={blog.title}
              excerpt={blog.excerpt}
              image={blog.image}
              author={blog.author}
              date={blog.date}
              tag={blog.tag}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

const sectionStyle = {
  padding: "60px 0",
  background: "#fafafa",
};

const containerStyle = {
  width: "min(1100px, 92%)",
  margin: "0 auto",
};

const headerStyle = {
  marginBottom: 24,
};

const gridStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: 18,
  justifyContent: "center",
};